/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'resources/less/themes/base/pages/standalone/faq.less';

import Popup from 'assets/js/modules/popup/PopupLight';

$(function() {
    $('.js-faq-answer-image').on('click', function() {
        var $img = $('<img/>', {
            src: $(this).data('full-image'),
            alt: $(this).data('alt')
        });
        var $popupEl = $('<div/>');
        var popup = new Popup($popupEl, {
            dialogClass: 'faq-popup',
            content: $img[0].outerHTML,
            close: function() {
                popup.destroy();
            },
            open: function() {
                $img.one('load', function() {
                    var dialogHeight = popup.getContainerHeight();
                    var contentHeight = popup.getHeight();
                    if (contentHeight > dialogHeight) {
                        popup.setHeight(dialogHeight);
                    }
                });
            }
        });
        popup.open();
    });

    var $categories = $('#categories');
    var $ul = $categories.find('ul');
    var $button = $categories.find('.expand-button');

    updateExpandButton();

    $categories.on('click', '.expand-button', function() {
        $ul.toggleClass('xs-open xs-closed');
        updateExpandButton();
    });

    function updateExpandButton() {
        var status = $ul.hasClass('xs-open') ? 'open' : 'closed';
        $button.text($button.data('text-' + status));
    }
});
